import { Injectable } from '@angular/core';
import { BaseService } from '../core/components/base.service';
import { Http, Response, RequestOptions, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { RequestUtil } from '../util/request.util';
import { SessionUtil } from '../util/session.util';
import { MessageService } from 'primeng/components/common/messageservice';
@Injectable()
export class TipologiasService extends BaseService<any>{

  private static TIPOLOGIA_RESOURCE: string = "/tipologias";

  constructor(protected http: Http, protected messageService: MessageService) {
    super(http, messageService);
  }

  public saveTipologia(tipologia: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    if (tipologia.id == null) {
      this.post(BaseService.URL_BASE + TipologiasService.TIPOLOGIA_RESOURCE, tipologia, options, onSuccess);
    } else {
      this.put(BaseService.URL_BASE + TipologiasService.TIPOLOGIA_RESOURCE, tipologia, options, onSuccess);
    }
  }

  public deleteTipologia(tipologia: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    this.delete(BaseService.URL_BASE + TipologiasService.TIPOLOGIA_RESOURCE + "/" + tipologia.id, options, onSuccess);
  }

  public getTipologia(id: any, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let options = new RequestOptions({ headers: headers });
    let params: URLSearchParams = RequestUtil.createURLSearchParams();
    this.get(BaseService.URL_BASE + TipologiasService.TIPOLOGIA_RESOURCE + "/" + id, params, options, onSuccess);
  }

  public getTipologias(tipologiaFilter: any, first: number, max: number, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_JSON, true);
    let params: URLSearchParams = RequestUtil.createURLSearchParams();
    if (first != null) {
      params.append("first", first.toString());
    }
    if (max != null) {
      params.append("max", max.toString());
    }
    let options = new RequestOptions({ headers: headers });
    this.get(BaseService.URL_BASE + TipologiasService.TIPOLOGIA_RESOURCE, params, options, onSuccess);
  }

}



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/services/tipologias.service.ts